import React from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { Link, useParams } from 'react-router-dom'
import { Modal } from 'react-bootstrap'

import industry from '@h2/assets/svg/icons/industry.svg'
import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import disllikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'

import {
  loadIndustry,
  rateIndustry,
  selectComparisonRegion
} from '../../actions/industry'
import {
  removeForComparison,
  retrieveComparisonRegions,
  selectForComparison
} from '../../actions/occupationProfile'
import { toggleModal } from '../../actions/modals'
import PopupJournal from '../../components/journal/PopupJournal'
import Share from '../../components/social/Share'
import ComparisonFooter from '../../components/ComparisonFooter'
import ComparisonRegionSelector from '../../components/ComparisonRegionSelector'
import { openSigninDialog } from '../../actions/signinOrRegisterDialog'
import LoadingIndicator from '../../components/LoadingIndicator'
import { useInitDispatch } from '../../util/hooks'

const IndustryProfile = ({
  selectedProfile,
  rateIndustry,
  modals,
  onToggleModal,
  openRegionsModal,
  onSelectRegion,
  selectedOccupations,
  onSelectOccupationForComparison,
  onRemoveOccupationForComparison
}) => {
  const params = useParams()

  useInitDispatch(loadIndustry(params.naics), [params.naics])

  if (!selectedProfile) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }

  const youAndIndustry = () => {
    const per = selectedProfile.personalization
    const rating = per && per.hasOwnProperty('rating') ? per.rating : null
    const comp =
      per && per.hasOwnProperty('compatibility') ? per.compatibility.score || 0 : 0
    const lastView = new Date(per.lastView).toLocaleDateString()

    return (
      <div>
        <div className=" youandocc">
          <h3>{t`You and This Industry`}</h3>
          <div className="row">
            <div className="useractions col-xs-8">
              <div className="itemrating">
                <a
                  href="javascript:void(0)"
                  onClick={() => rateIndustry(selectedProfile, 5)}>
                  <img
                    src={rating && rating > 3 ? like : likeInactive}
                    alt="Thumbs Up for Like Occupation Link"
                  />
                </a>
                <a
                  href="javascript:void(0)"
                  onClick={() => rateIndustry(selectedProfile, 1)}>
                  <img
                    src={rating && rating < 3 ? dislike : disllikeInactive}
                    alt="Thumbs down for Dislike Occupation Link"
                  />
                </a>
                {t`Your Rating`}
              </div>
            </div>
            <div className="col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4 className={(per?.journals ?? []).length ? 'hasData' : ''}>
                  {((per && per.journals) || []).length || 0}
                </h4>
                <span>{t`Journals`}</span>
                <button onClick={() => onToggleModal('journal', true)}>{t`Add`}</button>
              </div>
            </div>
          </div>
          {per.lastView && (
            <div className="lastView">{jt`You last viewed this on ${lastView}`}</div>
          )}
        </div>
      </div>
    )
  }
  const clusters = () => {
    const f = () => {
      if (selectedProfile.clusters) {
        return selectedProfile.clusters
          .sort((a, b) => b.percentageOfIndustry - a.percentageOfIndustry)
          .slice(0, 3)
          .map(c => (
            <li key={c.name}>
              <Link to={c.url}>{c.name}</Link>
            </li>
          ))
      }
    }

    console.log('About to output Top Pathways')
    console.log(t`Top Pathways`)

    return (
      <div className="section">
        <h3>
          <span>{t`Top Clusters`}</span>
        </h3>
        <ul>{f()}</ul>
      </div>
    )
  }
  const similar = () => {
    return (
      <div className="section">
        <h3>
          <span>{t`Sub Industries`}</span>
        </h3>
        <table className="table tbl">
          <thead>
            <tr>
              <th>{t`Industry`}</th>
            </tr>
          </thead>
          <tbody>
            {(selectedProfile.children || []).map((m, i) => (
              <tr key={m.id} className={i % 2 == 0 ? 'even' : 'odd'}>
                <td>
                  <Link to={m.url}>{m.title}</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
  const occs = () => {
    return (
      <div className="section">
        <h3>
          <span>{t`Occupations`}</span>
        </h3>
        <table className="table tbl">
          <thead>
            <tr>
              <th>
                <i
                  className="fal fa-eye"
                  title=""
                  aria-hidden="true"
                  title={t`Select up to three boxes below to see a side-by-side comparison of the items to the current occupation`}>
                </i>
              </th>
              <th>{t`Occupation`}</th>
              <th>{t`Job Zone`}</th>
              <th>{t`Percent of Industry`}</th>
            </tr>
          </thead>
          <tbody>
            {(selectedProfile.occupations || [])
              .sort((a, b) => b.percentOfIndustry - a.percentOfIndustry)
              .filter(a => a.percentOfIndustry > 1)
              .map((occ, i) => {
                const m = occ.occupation

                return (
                  <tr key={m.onetSoc} className={i % 2 == 0 ? 'even' : 'odd'}>
                    <td>
                      <input
                        id={`check-${m.onetSoc}`}
                        type="checkbox"
                        {...(selectedOccupations.indexOf(m.onetSoc) >= 0
                          ? { checked: true }
                          : {})}
                        onChange={s => {
                          if (s.target.checked) {
                            s.target.checked = !!onSelectOccupationForComparison(
                              m.onetSoc
                            )
                          } else {
                            return onRemoveOccupationForComparison(m.onetSoc)
                          }
                        }}
                      />
                    </td>
                    <td>
                      <Link to={m.url}>{m.title}</Link>
                      {selectedProfile.occupationMeta.inBudget[m.onetSoc] && (
                        <span
                          className="badge listing-badge budget defined"
                          title={t`This occupation would satisfy the salary requirements from your budget.`}>
                          <span>budget</span>
                        </span>
                      )}
                      {(selectedProfile.occupationMeta.flags[m.onetSoc] || []).map(f => (
                        <span
                          className={`badge listing-badge ${f.styleClass} defined`}
                          title={f.description}>
                          <span>{f.name}</span>
                        </span>
                      ))}
                    </td>
                    <td>
                      <div>
                        <div className="job-zone">{m.jobZone}</div>
                      </div>
                    </td>
                    <td>{occ.percentOfIndustry.toFixed(1)}%</td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      </div>
    )
  }
  const outlookElement = (ol, v, fmt) => {
    if (ol && ol.hasOwnProperty(v)) {
      if (fmt) {
        return ol[v].toLocaleString()
      }

      return ol[v]
    }

    return fmt ? 'n/a' : null
  }
  const toCurrency = inp => {
    if (!inp) {
      return 'n/a'
    }

    return inp
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      .slice(0, -3)
  }
  const toNum = inp => {
    if (!inp) {
      return 'n/a'
    }

    return inp.toLocaleString()
  }
  const parentIndustry = (
    <b>
      <Link to={selectedProfile?.parent?.url}>{selectedProfile?.parent?.title}</Link>
    </b>
  )
  const qcewLocalIndustryWage = selectedProfile?.wages?.find(w => w.naics != '10')

  console.log(selectedProfile?.comparisonWages)
  const qcewComparisonWage = selectedProfile?.comparisonWages?.find(w => w.naics != '10')

  return (
    <div id="profileinfocontainer">
      <div className="container">
        <div className="">
          <div className="headerBox row industry">
            <div className="title-section col-sm-5">
              <h3>{selectedProfile.title}</h3>
            </div>
            <div className="lmi-callout col-sm-5">
              <h4>
                {t`Annual Wage`}{' '}
                <a
                  href="javascript:void(0)"
                  onClick={() => openRegionsModal()}
                  className="pull-right lmi-location">
                  <i className="fal fa-map-marker" aria-hidden="true"></i>
                  {outlookElement(qcewLocalIndustryWage, 'region')}
                  {qcewComparisonWage ? (
                    <span className="comparison-region">
                      {' '}
                      / {outlookElement(qcewComparisonWage, 'region')}
                    </span>
                  ) : null}
                </a>
              </h4>
              <div style={{ height: '65px' }}>
                <h5>
                  {toCurrency(outlookElement(qcewLocalIndustryWage, 'averageAnnualWage'))}{' '}
                  {qcewComparisonWage ? (
                    <span className="comparison-region">
                      /{' '}
                      {toCurrency(
                        outlookElement(qcewComparisonWage, 'averageAnnualWage')
                      )}
                    </span>
                  ) : null}
                </h5>
                <br className="clear" />
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <h4>{t`Number of Establishments`}</h4>
                  <div style={{ height: '65px' }}>
                    <h5>
                      {toNum(
                        outlookElement(qcewLocalIndustryWage, 'numberOfEstablishments')
                      )}{' '}
                      {qcewComparisonWage ? (
                        <span className="comparison-region">
                          /{' '}
                          {toNum(
                            outlookElement(qcewComparisonWage, 'numberOfEstablishments')
                          )}
                        </span>
                      ) : null}
                    </h5>
                    <br className="clear" />
                  </div>{' '}
                </div>
                <div className="col-sm-6">
                  <h4>{t`Number of Employees`}</h4>
                  <div style={{ height: '65px' }}>
                    <h5>
                      {toNum(outlookElement(qcewLocalIndustryWage, 'numberOfEmployees'))}{' '}
                      {qcewComparisonWage ? (
                        <span className="comparison-region">
                          /{' '}
                          {toNum(outlookElement(qcewComparisonWage, 'numberOfEmployees'))}
                        </span>
                      ) : null}
                    </h5>
                    <br className="clear" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2 action-container">
              <a className="btn no-style media" href="javascript:void(0)" disabled={true}>
                <div
                  className="thumb"
                  style={{
                    backgroundImage: `url(${industry})`
                  }}>
                </div>
              </a>
              <a className="btn share" href="#" onClick={() => onToggleModal('share')}>
                <span className="sr-only">{t`Share`}</span>
              </a>
              <a className="btn print" href={selectedProfile.printUrl}>
                <span className="sr-only">{t`Print`}</span>
              </a>
              {/*<a className="btn" href="javascript:void(0)" onClick={() => onFlagOccupation(profile)}>
                                <i className="fal fa-flag" style={{ color: (selectedProfile.personalization && (selectedProfile.personalization.bookmarked || false)) ? "orange" : "initial" }}></i><span className="sr-only">{t`Bookmark`}</span>
                            </a> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <div className="section">
              <h3>
                <span>About this Industry</span>
              </h3>
              {!selectedProfile.description ? (
                <p>{t`Description not available`}</p>
              ) : (
                <p dangerouslySetInnerHTML={{ __html: selectedProfile.description }}></p>
              )}
              {selectedProfile.parent && selectedProfile.parent.id != '10' && (
                <p>{jt`This industry is part of the larger industry ${parentIndustry}.`}</p>
              )}
            </div>
            {occs()}
          </div>
          <div className="col-sm-4">
            {youAndIndustry()}
            {clusters()}
            {similar()}
          </div>
        </div>
      </div>
      <ComparisonFooter />
      <Modal
        bsSize="large"
        enforceFocus={false}
        show={modals && modals.selectedModal === 'journal'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Journal Entries`}</h2>
        </Modal.Header>
        <Modal.Body>
          {selectedProfile.personalization.journals && (
            <PopupJournal
              journals={selectedProfile.personalization.journals}
              objectType={selectedProfile.personalization.journalType}
              objectId={selectedProfile.id}
              objectTitle={selectedProfile.title}
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        show={modals && modals.selectedModal === 'share'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Social`}</h2>
        </Modal.Header>
        <Modal.Body>{<Share />}</Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        show={modals && modals.selectedModal === 'region'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Comparison Region Selector`}</h2>
        </Modal.Header>
        <Modal.Body>
          <ComparisonRegionSelector onSelectRegion={onSelectRegion(selectedProfile)} />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.industry.profile,
      modals: state.modals.industry,
      selectedOccupations: state.occupations.comparison.selectedOccupations
    }
  },
  dispatch => ({
    rateIndustry: (occupation, rating) => dispatch(rateIndustry(occupation, rating)),
    onSelectOccupationForComparison: itm => {
      console.log(itm)
      dispatch(selectForComparison(itm))
    },
    onToggleModal: (modalName, requireLoggedIn) => {
      if (!!requireLoggedIn && !dynamicValues.userProfile) {
        dispatch(openSigninDialog('signIn'))
      } else {
        dispatch(toggleModal('industry')(modalName))
      }
    },
    openRegionsModal: () => {
      dispatch(retrieveComparisonRegions()).then(() =>
        dispatch(toggleModal('industry')('region'))
      )
    },
    onSelectRegion: industry => {
      return region => {
        return dispatch(selectComparisonRegion(industry, region)).then(() =>
          dispatch(toggleModal('industry')(null))
        )
      }
    },
    onRemoveOccupationForComparison: itm => dispatch(removeForComparison(itm))
  })
)(IndustryProfile)
